<template>
    <q-layout view="hHh lpR fFf" style="display: grid">
        <q-page-container :style="`margin: auto;display: grid`">
            <q-card
                flat
                bordered
                :class="$q.screen.width < 485 ? `my-card-mobile` : `my-card`"
            >
                <q-card-section class="q-pt-xl">
                    <div class="row justify-center">
                        <q-img
                            basic
                            v-if="$q.screen.width < 485"
                            contain
                            width="50px"
                            :src="require('@/assets/logo-villa-mobile.svg')"
                        />
                        <q-img
                            basic
                            v-else
                            contain
                            width="100px"
                            :src="require('@/assets/logo-villa-mobile.svg')"
                        />
                    </div>
                    <div class="row justify-center">
                        <div class="text-h6">Villa market</div>
                    </div>
                </q-card-section>

                <q-card-section>
                    <div class="row justify-center">
                        <div class="text-h4">Sale Portal</div>
                    </div>
                </q-card-section>

                <q-card-section>
                    <q-btn
                        unelevated
                        no-caps
                        color="primary"
                        class="full-width"
                        block
                        label="Sign in"
                        @click="onSignIn"
                    />
                </q-card-section>
            </q-card>
        </q-page-container>
    </q-layout>
</template>

<style scoped>

.my-card {
    min-width: 360px;
}
.my-card-mobile {
    width: 100vw;
    height: 100vh;
    margin: auto;
}
.no-bold {
    font-weight: normal;
}
.welcome {
    display: grid;
    width: 100vw;
    height: 100vh;
}
.welcome-content {
    margin: auto;
    border: 1px solid red;
}

</style>

<script>
import { QBtn, QImg, QForm, QInput } from "quasar";

const components = { QBtn, QImg, QForm, QInput };

export default {
    name: "Welcome",
    components: {
        ...components,
    },
    data() {
        return {
            form: {
                username: null,
                password: null,
            },
        };
    },
    methods: {
        onSubmit() {
            console.log("Sign in");
            this.$router.push("/portal");
            return;
        },
        onSignIn(){
          console.log("Sign in");
          this.$router.push("/auth");
        },
        onSignUp() {
            console.log("Sign up");
            return;
        },
    },
};
</script>
